import { render, staticRenderFns } from "./VRegistration.vue?vue&type=template&id=01a0f032&scoped=true&lang=pug"
import script from "./VRegistration.vue?vue&type=script&lang=ts"
export * from "./VRegistration.vue?vue&type=script&lang=ts"
import style0 from "./VRegistration.vue?vue&type=style&index=0&id=01a0f032&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a0f032",
  null
  
)

/* custom blocks */
import block0 from "./VRegistration.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FAuth%2Fviews%2FRegistration%2FVRegistration.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports